<template>
  <v-dialog v-model="dialog.show" max-width="1400" persistent>
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="5">
            <v-card>
              <v-card-title>Empresas Não Vinculadas</v-card-title>
              <v-card-text>
                <draggable
                  v-model="empresasNaoVinculadas"
                  v-bind="dragOptions"
                  @remove="addDefaultNaoVinculados"
                  @add="removeDefaultNaoVinculado"
                >
                  <transition-group type="transition">
                    <v-list-item v-for="empresa in empresasNaoVinculadas" :key="empresa.cnpj">
                      <v-list-item-content>
                        <v-list-item-title v-html="empresa.nome"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </transition-group>
                </draggable>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col class="text-center" cols="2">
            <v-btn
              class="ma-1 pl-2 pr-2"
              outlined
              color="blue darken-1"
              small
              dark
              rounded
              depressed
              @click="desvincularTodas()"
            >
              <v-icon left>mdi-arrow-left</v-icon>Desvincular Todas
            </v-btn>

            <v-btn
              class="ma-3 pl-2 pr-2"
              outlined
              color="blue darken-1"
              small
              dark
              rounded
              depressed
              @click="vincularTodas()"
            >
              Vincular Todas
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="5">
            <v-card>
              <v-card-title>Empresas Vinculadas</v-card-title>
              <v-card-text>
                <draggable
                  v-model="empresasVinculadas"
                  v-bind="dragOptions"
                  @remove="addDefaultVinculados"
                  @add="removeDefaultVinculado"
                >
                  <transition-group type="transition">
                    <v-list-item v-for="empresa in empresasVinculadas" :key="empresa.cnpj">
                      <v-list-item-content>
                        <v-list-item-title v-html="empresa.nome"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </transition-group>
                </draggable>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="blue darken-1"
          small
          dark
          rounded
          depressedclass="ma-3 pl-5 pr-5"
          outlined
          depressed
          @click="save()"
        >Salvar</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import draggable from "vuedraggable";
import Empresa from "@/services/empresa";
import Veiculo from "@/services/veiculo";

export default {
  name: "VincularVeiculos",

  components: {
    draggable
  },

  data() {
    return {
      dialog: {
        show: false,
        title: ""
      },
      empresasVinculadas: [],
      empresasNaoVinculadas: [],
      empresas: [],
      veiculo: null,
      serviceVeiculo: new Veiculo()
    };
  },

  methods: {
    async show(veiculo) {
      try {
        if (this.empresas.length === 0) {
          await this.getEmpresas();
        }
        this.dialog.title = `Vincular empresas ao Veiculo ${veiculo.descricao}`;
        this.veiculo = { ...veiculo };
        this.filterEmpresasVinculadas();
        this.filterEmpresasNaoVinculadas();
        this.dialog.show = true;
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    filterEmpresasVinculadas() {
      for (const empresa of this.empresas) {
        for (const empresaVeiculo of this.veiculo.empresas) {
          if (empresa.cnpj === empresaVeiculo) {
            this.empresasVinculadas.push(empresa);
          }
        }
      }
      if (this.empresasVinculadas.length === 0) {
        this.empresasVinculadas.push({
          cnpj: 0,
          nome: "Não há empresas vinculadas"
        });
      }
    },

    filterEmpresasNaoVinculadas() {
      for (const empresa of this.empresas) {
        let not_in = true;
        for (const empresaVeiculo of this.veiculo.empresas) {
          if (empresa.cnpj === empresaVeiculo) {
            not_in = false;
          }
        }
        if (not_in) {
          this.empresasNaoVinculadas.push(empresa);
        }
      }
      if (this.empresasNaoVinculadas.length === 0) {
        this.empresasNaoVinculadas.push({
          cnpj: 0,
          nome: "Não há empresas não vinculadas"
        });
      }
    },

    async getEmpresas() {
      try {
        const empresas = await new Empresa().getAll();
        this.empresas = empresas.map(empresa => empresa);
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao Buscar Empresas");
        return Promise.reject(error);
      }
    },

    close() {
      this.empresasVinculadas = [];
      this.empresasNaoVinculadas = [];
      this.dialog.show = false;
    },

    async save() {
      try {
        this.removeDefaultVinculado();
        this.veiculo.empresas = this.empresasVinculadas.map(
          empresa => empresa.cnpj
        );
        await this.serviceVeiculo.update(this.veiculo.id, { ...this.veiculo });
        this.$emit("updated", this.veiculo);
        this.close();
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao atualizar dados");
        return Promise.reject(error);
      }
    },

    addDefaultVinculados() {
      if (this.empresasVinculadas.length === 0) {
        this.empresasVinculadas.push({
          cnpj: 0,
          nome: "Não há empresas vinculadas"
        });
      }
    },

    addDefaultNaoVinculados() {
      if (this.empresasNaoVinculadas.length === 0) {
        this.empresasNaoVinculadas.push({
          cnpj: 0,
          nome: "Não há empresas não vinculadas"
        });
      }
    },

    removeDefaultVinculado() {
      let index = this.empresasVinculadas.findIndex(
        empresa => empresa.cnpj === 0
      );
      index !== -1 ? this.empresasVinculadas.splice(index, 1) : null;
    },

    removeDefaultNaoVinculado() {
      const index = this.empresasNaoVinculadas.findIndex(
        empresa => empresa.cnpj === 0
      );
      index !== -1 ? this.empresasNaoVinculadas.splice(index, 1) : null;
    },

    vincularTodas() {
      let empresas = this.empresasNaoVinculadas.filter(
        empresa => empresa.cnpj !== 0
      );
      this.empresasNaoVinculadas = [];
      this.addDefaultNaoVinculados();
      this.removeDefaultVinculado();
      this.empresasVinculadas.push(...empresas);
    },

    desvincularTodas() {
      let empresas = this.empresasVinculadas.filter(
        empresa => empresa.cnpj !== 0
      );
      this.empresasVinculadas = [];
      this.addDefaultVinculados();
      this.removeDefaultNaoVinculado();
      this.empresasNaoVinculadas.push(...empresas);
    }
  },

  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  }
};
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: #939499;
}
</style>
